import React, { useEffect, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import "./assets/breakpoint.scss";
import "./App.css";
import { LoginRoute } from "./Routes/LoginRoute";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";
import { saveAzureTokenAction, storeUserDetailsAction } from "../src/Redux/Actions/actions";
import { CustomerRoute, ExternalRoute, MasterRoute, SiemensInternalRoute, SpecialUserRoute } from "./Routes/MasterRoute";
import { ResetPasswordRoute } from "./Routes/ResetPasswordRoute";
import { InteractionStatus } from "@azure/msal-browser";
import { specialUser } from "./../src/Screens/Login/Login";

import Header from "./Components/Header/Header";

import Loader from "./Components/Loader/Loader";
import {
    authenticateUserBasedOnValidToken,
    validateTheUserBasedOnApi,
} from "../src/APIs/api_Login";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import UnauthorizedAccess from "./Components/UnauthorizedAccess/UnauthorizedAccess";
import IdleTimer from "react-idle-timer";
import { saveAccessTokenAction } from "../src/Redux/Actions/actions";
import getPasswordValidity from "./Components/Header/Header";
import ExtHeader from "./Components/Header/ExtHeader";

import { useMsal } from '@azure/msal-react';

export default function App() {
    const auth = useAuth();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.saveTokenReducer.token);
    const userDetails = useSelector(
        (state) => state.storeUserDetailsReducer.userData
    );
 
    //const { instance, accounts } = useMsal();earlier
    const { instance, accounts, inProgress } = useMsal();
    const activeAccount = instance.getActiveAccount();
    const [isAuthorized, setIsAuthorized] = useState(true);

    const [isLoader, setIsLoader] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [unAuthText, setUnAuthText] = useState("");
    const isOTPVerified = useSelector((state) => state.isVerifiedOTPReducer);
    const isExternalOTPVerifiedVar = useSelector(
        (state) => state.isExternalOTPVerifiedReducer
    );
    const isForgotPassword = useSelector(
        (state) => state.isForgotPasswordReducer
    );

    const handleClose = (e, reason) => {
        if (reason === "backdropClick") {
            return;
        }
        setDialogOpen(false);
    };
   
    function sessionExpire(auth, dispatch) {
        var newurl =
            window.location.protocol +
            "//" +
            window.location.host +
            window.location.pathname;
        window.history.pushState({ path: newurl }, "", `/`);
        localStorage.clear();
        sessionStorage.clear();
        if (auth !== undefined) {
            dispatch(storeUserDetailsAction(""));

            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        }
        window.location.href = "/";
    }
   
    function authenticateUserWithGID(azureToken) {
       // let data = { gid: gid };
        authenticateUserBasedOnValidToken(dispatch, azureToken)
            .then((response) => {
                if (response.response) {
                    setUnAuthText("");
                    setDialogOpen(false);
                    setIsAuthorized(true);
                  
                } else {
                    
                    setIsAuthorized(false)
                    setUnAuthText(response.responseMsg);
                    setDialogOpen(true);
                    dispatch(storeUserDetailsAction({}));  //need to check
                  
                }

                
            })
            .catch((error) => {
              
                setUnAuthText("Exception occured while autheniticating user.");
                setDialogOpen(true);
            })
            .finally(() => {
                setIsLoader(false);
            })
;
    }

    const [hasAuthenticated, setHasAuthenticated] = useState(false);
    useEffect(() => {
        if (activeAccount && !hasAuthenticated) {
            setHasAuthenticated(true); 
            setIsLoader(true);
            dispatch(saveAzureTokenAction(activeAccount.idToken));
            authenticateUserWithGID(activeAccount.idToken);
           // specialUser(activeAccount.idToken);
        }
    }, [activeAccount, hasAuthenticated]);

   
    //useEffect(() => {
    //    if (activeAccount && isAuthorized && !userDetails?.id) {

    //   // setHasAuthenticated(true); 
           
    //       // setIsLoader(true);
    //        //let gid = accounts[0].idTokenClaims.gid;
    //        dispatch(saveAzureTokenAction(activeAccount.idToken));
    //        authenticateUserWithGID(activeAccount.idToken);
    //    } else {
    //        setIsLoader(false);
    //    }
    //}, [activeAccount, isAuthorized, !userDetails?.id]);
   /* [instance, accounts])//earlier dependency*/

    function logoutClick() {
        dispatch(saveAccessTokenAction(null));
      /*  auth.signoutRedirect();*/
        window.location = "https://myid.siemens.com/idp/startSLO.ping";
    }

   


    if (inProgress !== InteractionStatus.None) {
        return <Loader />;
    }

    if (isLoader) {
        return <Loader />;
    }

  

    return (
        <BrowserRouter>

            <div className="ssiat-master-block">
                {isExternalOTPVerifiedVar === true && userDetails.roleId <= 0 ? (
                    <div className="potts-master-block">
                        <ExtHeader>External Header</ExtHeader>
                        <main className="main-component">{ExternalRoute}</main>
                    </div>
                ) : isOTPVerified && isForgotPassword ? (
                    <div className="potts-master-block">
                        <Header>Header Component</Header>
                        <main className="main-component">{ResetPasswordRoute}</main>
                    </div>
                ) :
                    isLoader ? (
                        <Loader />
                        ) 
                     : (userDetails && userDetails.roleId > 0) || auth.user ? (
                        userDetails.roleId === 1 ? (
                            <div className="potts-master-block">
                                <Header />
                                <main className="main-component">{MasterRoute}</main>
                            </div>
                        ) : userDetails.roleId === 2 ? (
                            <div className="potts-master-block">
                                <Header />
                                <main className="main-component">{SpecialUserRoute}</main>
                            </div>
                        ) : userDetails.roleId === 3 ? (
                            <div className="potts-master-block">
                                <Header />
                                <main className="main-component">{CustomerRoute}</main>
                            </div>
                        ) : userDetails.roleId === 4 ? (
                            <div className="potts-master-block">
                                <Header />
                                <main className="main-component">{SiemensInternalRoute}</main>
                            </div>
                        ) : (
                            <></>
                        )
                    ) : (
                        LoginRoute
                    )}

            </div>
           
            <div>
                <IdleTimer
                    timeout={1000 * 60 * 10}
                    onIdle={sessionExpire}
                    debounce={250}
                />
            </div>
            <>
                <Dialog
                    disableEscapeKeyDown
                    open={dialogOpen}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {auth.error ? "Authentication Error" : "Un-Authorized"}
                    </DialogTitle>
                    <DialogContent>
                        <UnauthorizedAccess

                        />
                    </DialogContent>
                </Dialog>
            </>
            {isLoader ? <Loader loaderText="Loading...!" /> : <></>}
        </BrowserRouter>
    );
}
